import { useCallback, useMemo } from "react";
import { analyticsService } from "../analytics.service";
import { AnalyticsEvent } from "../enums/analytics-event.enum";
import { displayPopupWindow } from "../redux/display-slice";
import { ecommerce, EcommerceAction } from "../services/ecommerce.service";
import { useAppSelector } from "./redux.hook";
import { useDispatch } from 'react-redux';
import { useCreateLead } from "./leads.hook";
import { setActivePopupWidnowId } from "../redux/quiz-slice";
import { PopupWindowID } from "../enums/popup-window-id.enum";
import { WhatsAppInfo } from '../interfaces/whats-app-info.interface';
import { EcommerceProduct } from '../interfaces/ecommerce-product.interface';
import { device } from "../services/device-detector.service";
import { detect } from 'detect-browser';

const browser = detect();

type form_type = 'start_page_whatsapp' | 'whatsapp';
var windowReference: Window | null;

export const useWhatsappForm = (whatsappInfo: WhatsAppInfo, ecommerceObject: EcommerceProduct, form_type: form_type, callback?: () => void) => {
  const { receivedLead } = useAppSelector(state => state.quiz);
  const createLead = useCreateLead();
  const dispatch = useDispatch();

  const whatsappText = useMemo(() => {
    let text = whatsappInfo?.text || "";
    if (form_type == 'start_page_whatsapp') text = whatsappInfo?.textOnStartPage || text;
    if (form_type == 'whatsapp') text = whatsappInfo?.textOnFinalForm || text;
    return text;
  }, [whatsappInfo, form_type]);
  
  const afterGettingLead = useCallback((leadId: string) => {
    const url = `https://wa.me/${whatsappInfo?.phone}?text=${whatsappText}. Id: ${leadId}`;
    if (device.isIOS() && windowReference) {
      windowReference.location.href = url;
      setTimeout(() => windowReference && windowReference.close(), 1000);
    } else window.open(url, '_blank');
    
  }, [whatsappInfo, whatsappText]);
  
  const submitWhatsappForm = useCallback((e?: React.MouseEvent<HTMLElement> | React.FormEvent<HTMLFormElement>) => {
    e?.preventDefault();
    if (device.isIOS() && browser?.name !== "firefox") windowReference = window.open();
    analyticsService.send(AnalyticsEvent.CLICK_WHATSAPP_BUTTON);
    let leadId: string;
    
    if (!receivedLead) {
      createLead({ phone: "in-whatsapp", extra: { form_type } }).then(leadId => {
        afterGettingLead(leadId);
        callback && callback();

        setTimeout(() => {
          dispatch(setActivePopupWidnowId(PopupWindowID.WHATSAPP_INSTRUCTIONS));
          dispatch(displayPopupWindow(true));
          analyticsService.send(AnalyticsEvent.OPEN_WHATSAPP_INSTRUCTION);
        }, 1000);
        
        ecommerce.add(EcommerceAction.CART, { ...ecommerceObject, variant: 'whatsapp' });
        ecommerce.purchase(leadId);
      });
    } else {
      leadId = receivedLead.id;
      afterGettingLead(leadId);
      dispatch(displayPopupWindow(false));
    }
    
  }, [receivedLead, form_type, ecommerceObject, createLead, dispatch, afterGettingLead, callback]);

  return submitWhatsappForm;
}